
import Users_Rsidebar from "./Users_Rsidebar.js";

function RightSideBarExplore(){
   
    return(
        <div className="layout__right-sidebar">
            <div className="other-website">
                <div className="onther-website__block">
                    <div className="other-website__heading">OTHER WEBSITES<div/>
                        
                        <a href ="https://twitter.com/i/trends">click here to goto twitter<br/></a>
                        <a href ="https://www.facebook.com/">click here to goto facebook<br/></a>
                        <a href ="https://wits.ac.za/">click here to goto wits homepage<br/></a>
                        <a href ="https://instagram.com/">click here to goto instagram<br/></a>
                    </div>
                </div>
                    
            </div>

        </div>
     
    )
}

export default RightSideBarExplore;